import { Select } from 'components/ui/base/select/Select';
import styled, { createGlobalStyle } from 'styled-components';

export const GlobalSelectStyles = createGlobalStyle`
    .ant-select-dropdown .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
        background-color: var(--gray-4) !important;
    }
`;
export const StyledDeclarationSelect = styled(Select)<{ condensed?: boolean; lock?: boolean }>`
    width: 100%;

    ${({ lock }) => lock && 'border-top-right-radius: 0px !important; border-bottom-right-radius: 0px !important;'}

    display: flex;
    align-items: center;

    &.ant-select-show-search.ant-select > .ant-select-selector {
        border-radius: 6px;
        height: 32px;
        padding: 0 12px;
        font-size: 14px;
        line-height: 24px;
    }

    &.ant-select:not(.ant-select-disabled):hover .ant-select-selector {
        border-color: var(--brand-6);
    }

    .ant-select-selection-item,
    .ant-select-selection-placeholder {
        display: flex;
        align-items: center;
    }

    &.ant-select-focused .ant-select-selector {
        border-color: 1px solid var(--brand-6) !important;
        box-shadow: 0px 0px 4px 0px var(--box-shadow-1) !important;
        outline: none !important;
    }
`;

export const Wrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;
